export enum UpdateTimelineActivityType {
  PinToTop = 1,
  Unpin = 2,
  Status = 3,
}
